import { useEffect } from 'react';
import type { TransparencyReportingAuthorization } from 'src/apis/transparency-reporting/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleError } from 'src/utils/handle-error';
import { reportToSentry } from 'src/utils/report-to-sentry';

const transparencyReportingAuthorizationCacheKey =
  'transparency-reporting-authorization';

export function useTransparencyReportingAuthorization() {
  const response = useAxios(
    (axios, baseConfig) =>
      axios.request<TransparencyReportingAuthorization>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.transparencyReporting}/entrypoint/authorization`,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: transparencyReportingAuthorizationCacheKey,
    }
  );

  useEffect(() => {
    response.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return response;
}

export type TransparencyReportingAuthorizationRequest = ReturnType<
  typeof useTransparencyReportingAuthorization
>;

export function useOptionalTransparencyReportingAuthorization() {
  const response = useAxios(
    (axios, baseConfig) =>
      axios.request<TransparencyReportingAuthorization>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.transparencyReporting}/entrypoint/authorization`,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: transparencyReportingAuthorizationCacheKey,
      onError(error) {
        const [_, report] = handleError(error, () => {});
        if (report) reportToSentry(error);
        return error;
      },
    }
  );

  useEffect(() => {
    response.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return response;
}

export type OptionalTransparencyReportingAuthorizationRequest = ReturnType<
  typeof useOptionalTransparencyReportingAuthorization
>;
